<template xmlns="http://www.w3.org/1999/html">
  <div class="flex flex-col layout-product-card" @mouseover="eover()">

    <slot
        name="carousel"
        :prev="prev"
        :next="next"
        :urltransition="urltransition"
        :viewImage="viewImage"
        :product="product"
        :currentPhoto="currentPhoto"
        :checkCompare="checkCompare"
        :checkFavorite="checkFavorite"
        :activeCompare="activeCompare"
        :isFav="isFav"
        :offerActual="offerActual"
        :formatPrice="formatPrice"
    ></slot>
    <slot
        name="content"
        :realGoal="realGoal"
        :prop="prop"
        :fetchOffer="fetchOffer"
        :sizeSelectOpened="sizeSelectOpened"
        :addCardNotify="addCardNotify"
        :priceRequest="priceRequest"
        :loadingSize="loadingSize"
        :selectSize="selectSize"
        :product="product"
        :offerActual="offerActual"
        :dateDelivery="dateDelivery"
        :formatPrice="formatPrice"
        :closeSizes="closeSizes"
        :closeHars="closeHars"
        :charsShow="charsShow"
        :charsview="charsview"
        :key="product.OFFER_ID_SELECTED"
        :hiddenCharsOpened="hiddenCharsOpened"
    ></slot>

    <div v-if="Object.keys(product).length > 0 && !firstload" class="carousel-wrapper">
      <div class="carousel">
        <div
            class="images"
            @click="urltransition()"
            :style="{
            transform: `translate3d(calc(100% * ${currentPhoto} * -1),0,0)`
          }"
        >
          <div class="image">
            <img class="load" :realsrc="product.DETAIL_PICTURE.SRC" src="/images/load.svg" :alt="product.NAME">
          </div>
          <!-- viewImage -->
          <div v-if="viewImage && product.MORE_PHOTO && product.MORE_PHOTO.length>1" v-for="(productMorePhoto, i) in product.MORE_PHOTO" :key="i" class="image">
            <!--            <img v-lazy="productMorePhoto.SRC" :alt="product.NAME+i">-->
            <img :src="productMorePhoto.SRC" :alt="product.NAME+i">
          </div>
        </div>
        <!--  -->
      </div>
      <div v-if="product.MORE_PHOTO && product.MORE_PHOTO.length>1" class="dots-indicator">
        <div class="dot" :class="[{ active: dot - 1 === currentPhoto }]" v-for="dot in product.MORE_PHOTO.length" :key="dot"></div>
      </div>
      <div v-if="product.MORE_PHOTO && product.MORE_PHOTO.length>1" class="arrows abs xs-hide">
        <ui-arrow-button @click="prev" to="left"></ui-arrow-button>
        <ui-arrow-button @click="next" to="right"></ui-arrow-button>
      </div>
      <div class="labels">
        <ui-label v-if="product.OFFER_NAL" class="s-10 uppercase">В наличии</ui-label>
        <ui-label v-if="offerActual && offerActual.MIN_PRICE && offerActual.MIN_PRICE.DISCOUNT_DIFF_PERCENT > 0"
                  main
                  class="s-10 uppercase">
          SALE {{ offerActual.MIN_PRICE.DISCOUNT_DIFF_PERCENT }}%</ui-label>
        <ui-label v-if="product.STORE" white slot="label" class="uppercase s-10">В шоуруме</ui-label>
      </div>
      <div class="absolute flex gap-1 right-2 top-2">
        <div title="Сравнение" v-if="offerActual && product.OFFERS.length && product.TYPE_PRODUCT!='set'" class="icon-button pretty-button" @click="checkCompare" :class="[{ activeCompare }]">
          <icon-side></icon-side>
        </div>
        <div v-if="offerActual" title="Избранное" @click="checkFavorite" :class="[{ active: isFav }]" class="icon-button fav-button">
          <icon-heart></icon-heart>
        </div>
      </div>
      <div class="images-bottom">
        <div class="comments">
          <template v-if="product.REV && product.REV.COUNT && Number(product.REV.COUNT)>0">
            <icon-comment></icon-comment>
            {{ product.REV.REVTEXT }}
          </template>
        </div>
      </div>
    </div>
    <div v-if="Object.keys(product).length > 0 && !firstload" class="flex flex-col flex-grow content">
      <!--  -->
      <div class="header">
        <div class="s-20 w-600 name">
          <a v-if="offerActual && offerActual.CODE" @click="realGoal()" target="_blank" :href="'/catalog/'+offerActual.CODE+'/'" :title="offerActual.CODE" v-html="product.NAME"></a>
          <span v-else :title="product.NAME" v-html="product.NAME"></span>
        </div>
      </div>
      <div class="data" :class="[{'grid-template': product.TYPE_PRODUCT !== 'set' && product.COLLECTION}]">
        <div class="leading-none s-14 desc">
          <div v-if="product.PROPERTIES.SHORT_DESCRIPTION && product.PROPERTIES.SHORT_DESCRIPTION.VALUE" v-html="product.PROPERTIES.SHORT_DESCRIPTION.VALUE"></div>
        </div>
        <!-- Колекции -->
        <div class="colors" v-if="product.TYPE_PRODUCT !== 'set' && product.COLLECTION">
          <template v-for="(offer, index) in product.OFFERS">

            <a v-if="index <= 5"
               :class="[{active: product.CODE.replace(/_main/i, '')==offer.CODE}]"
               :style="'--color: url('+offer.MIN_PREVIEW_PICTURE.SRC+')'"
               :dataId="offer.ID"
               :href="'/catalog/'+offer.CODE+'/'"
               :title="offer.NAME">
              ></a>
<!--            <a v-else-if="index > 5" :href="product.CODE.replace(/_main/i, '')" :title="offer.NAME">
              +{{ product.OFFERS.length-5 }}
            </a>-->

          </template>
        </div>
      </div>
      <div class="chars">
        <div v-if="product.PROPFIRST && product.PROPFIRST.length" class="flex justify-between mt-5">
          <div v-for="(propFirst, index) in product.PROPFIRST" class="char-item">
            <img v-if="propFirst.img" :src="propFirst.img" alt="">
            <div>
              <span>{{ propFirst.name }}</span>
              <div>{{ propFirst.value }}</div>
            </div>
          </div>
        </div>
        <div v-if="product.PROPFIRST_SHESTKOST && product.PROPFIRST_SHESTKOST.length" class="grid grid-cols-2 gap-8 mt-5">
          <div v-for="(propFirstShestkost, index) in product.PROPFIRST_SHESTKOST" class="char-item">
            <img v-if="propFirstShestkost.img" :src="propFirstShestkost.img" alt="">
            <div>
              <span>{{ propFirstShestkost.name }}</span>
              <section>
                <div :style="'width: '+propFirstShestkost.value+'%'" :class="'w-['+propFirstShestkost.value+'%] bg-accent h-full'"></div>
              </section>
              <div>{{ propFirstShestkost.nameVal }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex items-center justify-between pb-2 mt-4 mb-auto">
        <template v-if="offerActual && product.TYPE_PRODUCT !== 'set' && offerActual.MIN_PRICE.DISCOUNT_VALUE !== 1 ">
          <div v-click-outside="closeSizes" class="size-select-wrapper size-select-card-wrapper"
             v-if="(
                 ( offerActual.PROPERTIES && offerActual.PROPERTIES.GABARITY && offerActual.PROPERTIES.GABARITY.VALUE ) ||
			            ( offerActual.PROPERTIES && offerActual.PROPERTIES.RAZMER && offerActual.PROPERTIES.RAZMER.VALUE ) ||
			            ( offerActual.PROPERTIES && offerActual.PROPERTIES.DIAMETR && offerActual.PROPERTIES.DIAMETR.VALUE ) ||
			            ( offerActual.PROPERTIES && offerActual.PROPERTIES.MATERIAL_TYPE && offerActual.PROPERTIES.MATERIAL_TYPE.VALUE )
              )"
        >
          <div
              @click="fetchOffer('fetch')"
              class="size-select has-icon-left"
              :key="product.OFFER_ID_SELECTED"
          >
            <span class="s-14 w-600" v-if="offerActual.PROPERTIES.GABARITY && offerActual.PROPERTIES.GABARITY.VALUE">{{ offerActual.PROPERTIES.GABARITY.VALUE }}</span>
            <span class="s-14 w-600" v-else-if="offerActual.PROPERTIES.RAZMER && offerActual.PROPERTIES.RAZMER.VALUE">{{ offerActual.PROPERTIES.RAZMER.VALUE }}</span>
            <span class="s-14 w-600" v-else-if="offerActual.PROPERTIES.DIAMETR && offerActual.PROPERTIES.DIAMETR.VALUE">{{ offerActual.PROPERTIES.DIAMETR.VALUE }}</span>
            <span class="s-14 w-600" v-if="offerActual.PROPERTIES.MATERIAL_TYPE && offerActual.PROPERTIES.MATERIAL_TYPE.VALUE">
                  - {{offerActual.PROPERTIES.MATERIAL_TYPE.VALUE}}
              </span>
            <icon-arrow-dropdown></icon-arrow-dropdown>
          </div>
          <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
            <div class="options" :class="[{ scrolled: product.OFFERS.length > 6 }]" v-if="sizeSelectOpened">
              <vue-scroll
                  :ops="{
                    bar: {
                      background: '#323b53'
                    }
                  }"
              >

                <div v-if="loadingSize" class="lds-ripple"><div></div><div></div></div>

                <div
                    :class="[{ active: offerActual.ID === offer.ID }]"
                    v-for="(offer, index) in product.OFFERS"
                    :key="product.OFFER_ID_SELECTED+index"
                    :title="offer.NAME"
                    class="s-14 w-600 selectItem"
                    @click="selectSize(offer)"
                >
                  &nbsp;
                  <span v-if="offer.PROPERTIES.GABARITY && offer.PROPERTIES.GABARITY.VALUE">{{ offer.PROPERTIES.GABARITY.VALUE }}</span>
                  <span v-else-if="offer.PROPERTIES.RAZMER && offer.PROPERTIES.RAZMER.VALUE">{{ offer.PROPERTIES.RAZMER.VALUE }}</span>
                  <span v-else-if="offer.PROPERTIES.DIAMETR && offer.PROPERTIES.DIAMETR.VALUE">{{ offer.PROPERTIES.DIAMETR.VALUE }}</span>
                  <span v-if="offer.PROPERTIES.MATERIAL_TYPE && offer.PROPERTIES.MATERIAL_TYPE.VALUE">
                      - {{offer.PROPERTIES.MATERIAL_TYPE.VALUE}}
                  </span>
                </div>


              </vue-scroll>
            </div>
          </transition>
        </div>
          <div class="uppercase delivery s-12 w-600">
          <icon-delivery></icon-delivery>
          <div v-html="dateDelivery(offerActual)"></div>
        </div>
        </template>
      </div>
      <!-- bottom -->
      <div v-if="offerActual && product.TYPE_PRODUCT !== 'set'" class="relative mt-2 bottom">
        <div
            @click="charsShow"
            class="flex items-center justify-center h-10 mb-2 text-sm font-medium duration-200 cursor-pointer rounded-xl"
            :class="[{'bg-light': !hiddenCharsOpened},{'bg-accent text-white': hiddenCharsOpened}]"
        >
          {{ !hiddenCharsOpened ? 'Все характеристики' : 'Свернуть характеристики' }}
        </div>
        <div class="hidden-chars ui-scroll" :class="[{ active: hiddenCharsOpened }]">
          <div v-for="(pr, index) in prop">
            <div><img src="/images/vs-icon-char.svg" :alt="pr.NAME+'char'"></div>
            <span><span v-html="pr.NAME"></span> <b>{{ pr.VALUE }}</b></span>
          </div>
        </div>

        <ui-button v-if="Number(offerActual.MIN_PRICE.DISCOUNT_VALUE) === 1" class="!rounded-full w-full" @click="priceRequest">
          <span>Рассчитать стоимость</span>
        </ui-button>

        <ui-button v-else class="!rounded-full w-full" @click="addCardNotify">
          <icon-cart></icon-cart><span v-html="formatPrice( offerActual.MIN_PRICE.DISCOUNT_VALUE )"></span> <span v-if="offerActual && offerActual.MIN_PRICE && offerActual.MIN_PRICE.DISCOUNT_DIFF_PERCENT > 0" class="mx-2 text-sm line-through opacity-40" v-html="formatPrice( offerActual.MIN_PRICE.VALUE )"></span></ui-button>

      </div>
      <!--  -->
      <layout-popup v-model="popupOpened" :sended="sended">
        <div class="s-30 w-500">Купите в 1 клик</div>
        <div class="s-16 opacity-80">Оставьте Ваш номер телефона, мы перезвоним</div>
        <template slot="form">
          <input required placeholder="Как Вас зовут" name="name" type="text" v-model="name" class="ui-input" />
          <input v-model="phone" class="ui-input" type="tel" placeholder="Введите телефон" required />
<!--          <phone-mask-input
              v-model="phone"
              autoDetectCountry
              @onValidate="onValidate"
              inputClass="ui-input"
              placeholder=""
              required
          />-->
          <!--        <input required placeholder="+7 (000) 000 00 00" type="phone" name="phone" v-model="phone" class="ui-input" />-->
          <ui-button @click="oneAddOrder">Оставить заявку</ui-button>
        </template>
        <div slot="suffix" class="s-12">
          Оставляя Ваш телефон, вы соглашаетесь с <a class="underline" href="/politica/" title="Политика обработки персональных данных">политикой обработки персональных данных</a>
        </div>
      </layout-popup>
  </div>
    <layout-popup v-model="popupOpenedPriceRequest" :sended="sended">
      <div class="s-30 w-500">Рассчитать стоимость</div>
      <div class="s-16 opacity-80">Оставьте Ваш номер телефона, мы перезвоним</div>
      <template slot="form">
        <input required placeholder="Как Вас зовут" name="name" type="text" v-model="name" class="ui-input" />
        <input v-model="phone" class="ui-input" type="tel" placeholder="Введите телефон" required />
        <ui-button @click="sendFeedback('Рассчитать стоимость' )" >Отправить</ui-button>
      </template>
      <div slot="suffix" class="s-12">
        Оставляя Ваш телефон, вы соглашаетесь с <a class="underline" href="/politica/" title="Политика обработки персональных данных">политикой обработки персональных данных</a>
      </div>
    </layout-popup>
  </div>
</template>

<script>
import PhoneMaskInput from  "vue-phone-mask-input";
import ClickOutside from 'vue-click-outside';

export default {
  components: {
    PhoneMaskInput,
    iconSide: () => import('@/components/icon/icon-side'),
    vueScroll: () => import('vuescroll'),
    'ui-arrow-button': () => import('@/components/ui/ui-arrow-button'),
    'ui-button': () => import('@/components/ui/ui-button'),
    'ui-label': () => import('@/components/ui/ui-label'),
    'icon-heart': () => import('@/components/icon/icon-heart'),
    'icon-star': () => import('@/components/icon/icon-star'),
    'icon-bag': () => import('@/components/icon/icon-bag'),
    'icon-click': () => import('@/components/icon/icon-click'),
    'layout-popup': () => import('@/components/layout/layout-popup'),
    'icon-arrow-dropdown': () => import('@/components/icon/icon-arrow-dropdown'),
    'ui-raiting': () => import('@/components/ui/ui-raiting'),
    'icon-delivery': () => import('@/components/icon/icon-delivery'),
    'icon-comment': () => import('@/components/icon/icon-comment'),
    'ui-char-scale': () => import('@/components/ui/char/ui-char-scale.vue'),
    'ui-char-value': () => import('@/components/ui/char/ui-char-value.vue'),
    'ui-char-flags': () => import('@/components/ui/char/ui-char-flags.vue'),
  },
  props: {
    updateSizeAll: {
      type: Boolean,
      default() {
        return false
      }
    },
    firstload: {
      type: Boolean,
      default() {
        return false
      }
    },
    inShowroom: {
      type: Boolean,
      default() {
        return false
      }
    },
    product: {},
    value: {},
    favoritedelete: false
  },
  data() {
    return {
      activeCompare: false,
      viewImage: false,
      loadingSize: false,
      popupOpened: false,
      popupOpenedPriceRequest: false,
      isFav: false,
      currentPhoto: 0,
      size: '',
      sizes: [],
      prop: [],
      sizeSelectOpened: false,
      hiddenHeight: 0,
      offerActual: {},
      phone: '',
      name: '',
      site_id: this.$store.state.langs.SITE_ID,
      checkFetchOffer: false,
      sended: false,
      queryProp: false,
      arPropImg: this.$store.state.langs.PROPERTY_IMG,
      clickToCart: false,
      totalSize: {},
      validPhone: false,
      charsview: false,
      hiddenCharsOpened: false
    }
  },
  mounted() {
    this.initColorsChoice();
    if (window.innerWidth < 768) {
      this.initSwiper()
    }
  },
  created () {
    if( this.product && this.product.OFFERS && this.product.OFFERS.length>0 ) {
      this.offerActual = this.product.OFFERS.find(off => off.ID === this.product.OFFER_ID_SELECTED);
    }
    this.site_id = this.$store.state.siteid;
    var cookieFavorite = this.$cookie.get('favorites');
    if( cookieFavorite ){
      var favoriteJson = JSON.parse(cookieFavorite);
      if(this.offerActual && favoriteJson[this.site_id] && favoriteJson[this.site_id][this.offerActual.IBLOCK_ID] && favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID)){
        this.isFav = true;
      }else{
        this.isFav = false;
      }
    }
    this.$bus.$on('updateSended', () => {
      this.sended=false;
    });

    this.$bus.$on('upadateSizeProductCard', (sizeActual) => {
      this.totalSize=sizeActual;
      this.upadateSizeProductCard();
    });

    var cookieCompare = this.$cookie.get('compare');
    if( cookieCompare ){
      var compareJson = JSON.parse(cookieCompare);
      if(this.offerActual && compareJson[this.site_id] && compareJson[this.site_id][this.offerActual.IBLOCK_ID] && compareJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID)){
        this.activeCompare = true;
      }else{
        this.activeCompare = false;
      }
    }

  },
  directives: {
    ClickOutside
  },
  methods: {
    initSwiper() {
      const Hammer = require('hammerjs')
      const hammertime = new Hammer(this.$el.querySelector('.carousel-wrapper'))
      hammertime.on('swipeleft', () => {
        this.next()
      })
      hammertime.on('swiperight', () => {
        this.prev()
      })
    },
    hiddenHandler() {},
    initColorsChoice() {
      const colors = [...this.$el.querySelectorAll('.colors >*')]
      for (const color of colors) {
        color.addEventListener('click', () => {
          colors.forEach(c => c.classList.remove('active'))
          color.classList.add('active')
        })
      }
    },
    selectSize(offer) {
      //if( type == "size" ){
      this.$emit('update:value', this.value);
      ///  this.$bus.$emit("updateSizeOffersProduct", offer);
      //}else{
      this.offerActual = offer;
      this.product.OFFER_ID_SELECTED = offer.ID;
      //}
      let sizeActual={}

            if (offer.PROPERTIES.GABARITY && offer.PROPERTIES.GABARITY.VALUE){
              sizeActual.name="GABARITY";
              sizeActual.RAZMER=0;
              sizeActual.GABARITY=offer.PROPERTIES.GABARITY.VALUE;
              sizeActual.DIAMETR=0;
            }else if (offer.PROPERTIES.RAZMER && offer.PROPERTIES.RAZMER.VALUE){
              sizeActual.name="RAZMER";
              sizeActual.RAZMER=offer.PROPERTIES.RAZMER.VALUE;
              sizeActual.gabarity=0;
              sizeActual.DIAMETR=0;
            }else if (offer.PROPERTIES.DIAMETR && offer.PROPERTIES.DIAMETR.VALUE){
              sizeActual.name="DIAMETR";
              sizeActual.RAZMER=0;
              sizeActual.GABARITY=0;
              sizeActual.DIAMETR=offer.PROPERTIES.DIAMETR.VALUE;
            }
            if(offer.PROPERTIES.MATERIAL_TYPE && offer.PROPERTIES.MATERIAL_TYPE.VALUE){
              sizeActual.materialtype=offer.PROPERTIES.MATERIAL_TYPE.VALUE;
            }else{
              sizeActual.materialtype=0;
            }
            if(this.updateSizeAll) {
              this.$bus.$emit("upadateSizeProductCard", sizeActual);
              //this.updateSizeSession();
            }

      this.sizeSelectOpened = false;
    },
    updateSizeSession(){
      setTimeout(() => {
        var razmer = "";
        if(this.totalSize.DIAMETR){
          var razmer = this.totalSize.DIAMETR;
        }else if(this.totalSize.GABARITY){
          var razmer = this.totalSize.GABARITY;
        }else if(this.totalSize.RAZMER){
          var razmer = this.totalSize.RAZMER;
        }

        var bodyFormData = new FormData();
        bodyFormData.append('iblock_id', this.product.IBLOCK_ID);
        bodyFormData.append('gabarity',  razmer);

        this.$axios({
          url: '/ajax/size-session.php/',
          headers: { "Content-Type": "multipart/form-data" },
          method: 'post',
          data: bodyFormData
        }).then(response => {});
      }, 500);
    },
    upadateSizeProductCard(){
      if( !this.checkFetchOffer ){
        this.fetchOffer( "upadateSize" );
      }else{
        let offerSize = this.product.OFFERS.find( (v)  => {
            let g = v.PROPERTIES.GABARITY.VALUE===this.totalSize.GABARITY;
            if( this.totalSize.materialtype !== 0 ){
              let m = v.PROPERTIES.MATERIAL_TYPE.VALUE===this.totalSize.materialtype;
              return g && m;
            }else{
              return g;
            }
        });
        if(offerSize){
          this.offerActual=offerSize;
          this.product.OFFER_ID_SELECTED = offerSize.ID;
        }
      }
    },
    prev() {
      this.viewImage = true;
      if (this.currentPhoto !== 0) {
        this.currentPhoto--
      } else {
        this.currentPhoto = this.product.MORE_PHOTO.length - 1
      }
    },
    next() {
      this.viewImage = true;
      if (this.currentPhoto !== this.product.MORE_PHOTO.length - 1) {
        this.currentPhoto++
      } else {
        this.currentPhoto = 0
      }
    },
    formatPrice(price) {
      return Math.ceil(Number(price)).toLocaleString() + " <span class='ruble'>"+ this.$store.state.langs.CURRENCY_SING+"</span>"
    },
    checkimg( imgName, iblock_id ){
      var checkImg = false;
      if( typeof this.arPropImg[Number(iblock_id)] != "undefined" && this.arPropImg[Number(iblock_id)].some(item => item === imgName) ){
        checkImg = true;
      }else if ( this.arPropImg.other.some(item => item === imgName) ){
        checkImg = true;
      }
      /*
      if( arProp.indexOf(imgName) < 0 ) return false;

      var checkImg = false;
      var img = new Image();
      //img.src = '/images/property/'+imgName.toLowerCase()+'.svg';
      img.src = '/images/property/'+imgName+'.svg';
      img.onload = function(){checkImg=true};
      img.onerror = function(){checkImg=false};

      console.log("checkImg", checkImg);

      return checkImg;
      */
      return checkImg;
    },
    urltransition(){
      if (typeof (ym) === "function") {
        let yaCounterId = this.$store.state.langs.YACOUNTER;
        ym(yaCounterId, 'reachGoal', 'product_click');
      }
      if(this.offerActual) {
        window.open('/catalog/' + this.offerActual.CODE + '/');
      }
      //location.href=url;
    },
    realGoal(){
      if (typeof (ym) === "function") {
        let yaCounterId = this.$store.state.langs.YACOUNTER;
        ym(yaCounterId, 'reachGoal', 'product_click');
      }
    },
    addToCard(){
      var ids = [];
      ids.push(this.offerActual.ID);
      this.$axios({
        url: '/ajax/?id='+ids+'&add_basket=Y&CATALOG_ID='+this.$store.state.langs.CATALOG_ID+'&GROUP_USER_ID='+this.$store.state.langs.GROUP_USER_ID+'&SITE_ID='+this.$store.state.siteid+'&FUSER_ID='+this.$store.state.fuserid, method: 'post'
      }).then(response => {
        if (response.status == 200) {
          //console.log('response: ' + response)
          var count = Number(response.data.productCount);
          this.$bus.$emit("smallbasket", count);
          let productBascet = {name:this.offerActual.NAME,price:this.formatPrice( this.offerActual.MIN_PRICE.DISCOUNT_VALUE ),image:this.product.DETAIL_PICTURE.SRC}
          this.$bus.$emit('in-cart', productBascet);
          let brand = ( this.product.PROPERTIES.PROIZVODITEL &&  this.product.PROPERTIES.PROIZVODITEL.VALUE) ? this.product.PROPERTIES.PROIZVODITEL.VALUE : "" ;
          window.dataLayer = window.dataLayer || [];
          dataLayer.push({
            "ecommerce": {
              "currencyCode": "RUB",
              "add": {
                "products": [
                  {
                    "id": this.offerActual.ID,
                    "name" : this.offerActual.NAME,
                    "price": this.offerActual.MIN_PRICE.DISCOUNT_VALUE,
                    "brand": brand,
                    "category":  ( typeof this.product.iblockInfo !== "undefined" ) ? this.product.iblockInfo.NAME + "/" + brand + "/" + this.offerActual.NAME : '',
                    "variant" : this.offerActual.PROPERTIES.GABARITY.VALUE,
                    "quantity": 1
                  }
                ]
              }
            }
          });
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'add2cart');

            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'add_to_cart');
          }

        }
      }).catch(e => {
        console.log('Error: ' + e)
      });
    },
    addCardNotify(){
      if( !this.clickToCart ) {
        this.addToCard();
        this.clickToCart=true;
      }else{
        document.location.href="/cart/";
      }
    },
    fetchOffer( type ){



      if( !this.checkFetchOffer ) {
        this.loadingSize=true;
        var bodyFormData = new FormData();
        bodyFormData.append('id', this.product.ID);
        bodyFormData.append('iblock_id', this.product.IBLOCK_ID);
        bodyFormData.append('siteid', this.$store.state.siteid);
        bodyFormData.append('totalSize',  JSON.stringify(this.totalSize));

        this.$axios({
          url: '/ajax/offers-product.php/',
          headers: { "Content-Type": "multipart/form-data" },
          method: 'post',
          data: bodyFormData
        }).then(response => {
          if (response.status == 200) {
            if(response.data) {
              this.product.OFFERS = response.data;
              if( Object.keys(this.totalSize).length ){
                let offerSize = this.product.OFFERS.find( (v)  => {
                  let g = v.PROPERTIES.GABARITY.VALUE===this.totalSize.GABARITY;
                  if( this.totalSize.materialtype !== 0 ){
                    let m = v.PROPERTIES.MATERIAL_TYPE.VALUE===this.totalSize.materialtype;
                    return g && m;
                  }else{
                    return g;
                  }
                });
                if(offerSize){
                  this.offerActual=offerSize;
                  this.product.OFFER_ID_SELECTED = offerSize.ID;
                }
              }
              this.checkFetchOffer = true;
            }
            this.loadingSize=false;
          }
        }).catch(e => {
          console.log('Error: ' + e)
          this.loadingSize=false;
        });
      }
      if( type !== "upadateSize" ) {
        this.sizeSelectOpened = !this.sizeSelectOpened;
      }
    },
    oneAddOrder(){
      /*if( !this.validPhone ){return false;}*/
      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }
      var ids = [];
      ids.push(this.offerActual.ID);

      this.$axios({
        url: '/ajax/?id='+ids+'&by_one_click=Y&siteid='+this.$store.state.siteid+'&phone='+this.phone+'&name='+this.name, method: 'post'
      }).then(response => {
        if (response.status == 200) {

          if (typeof (ym) === "function") {
            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'buy_1_click');
            ym(yaCounterId2, 'reachGoal', 'all_forms');
          }

          //console.log('response: ' + response)
          this.sended = true;
        }
      }).catch(e => {
        console.log('Error: ' + e)
      });
    },
    onValidate(ev){
      this.validPhone = !!ev.isValidByLibPhoneNumberJs;
    },
    checkFavorite(){
      this.isFav = !this.isFav;
      var cookieFavorite = this.$cookie.get('favorites');
      var favoriteJson = {};
      if( cookieFavorite ){
        favoriteJson = JSON.parse(cookieFavorite);
        if( this.isFav ) { //add
          if( !favoriteJson[this.site_id] ){
            favoriteJson[this.site_id]={};
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if( !favoriteJson[this.site_id][this.offerActual.IBLOCK_ID] ){
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          var searchId = favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID);
          if( !searchId ){
            favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'add2favorites');

            let yaCounterId2 = this.$store.state.langs.YACOUNTER2;
            ym(yaCounterId2, 'reachGoal', 'favorites');
          }
        }else{ // remove
          favoriteJson[this.site_id][this.offerActual.IBLOCK_ID] = favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].filter((n) => {return n != this.offerActual.ID});
        }
      }else{
        favoriteJson[this.site_id]={};
        favoriteJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
        favoriteJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
      }
      this.$cookie.set('favorites', JSON.stringify(favoriteJson))
      var cuntFavorites = 0;
      for (var key in favoriteJson[this.site_id]) {
        cuntFavorites = cuntFavorites + favoriteJson[this.site_id][key].length;
      }
      this.$bus.$emit("favorite", cuntFavorites);
    },
    charsShow() {
      //this.charsview = true
      this.hiddenCharsOpened = !this.hiddenCharsOpened;
    },
    closeHars() {
      this.charsview = false
    },
    closeSizes() {
      this.sizeSelectOpened = false
    },
    eover(){
      this.viewImage = true;
      if( this.product && !this.queryProp ) {
        this.queryProp = true;
        this.$axios({
          url: '/ajax/product-property.php/?id=' + this.product.ID + '&siteid=' + this.$store.state.siteid,
          method: 'post'
        }).then(response => {
          if (response.status == 200) {
            if(response.data) {
              //this.product.PROPERTIES = response.data;
              this.prop = response.data;
            }
          }
        }).catch(e => {
          console.log('Error: ' + e)
        });
      }
    },
    dateDelivery(offer){
      let resDate = "На заказ";
      let date = new Date();
      if(this.product.STORE || this.product.STORE_UD_SKLAD || ( offer && offer.CATALOG_QUANTITY && Number(offer.CATALOG_QUANTITY) > 0 ) ){
        resDate = "Завтра";
      }else if( this.product.PROPERTIES.SROK_DOSTAVKI && this.product.PROPERTIES.SROK_DOSTAVKI.VALUE ) {
        let propDate = this.product.PROPERTIES.SROK_DOSTAVKI.VALUE;
        if(propDate==="1 день" || propDate==="В наличии"){
          //date.setDate(date.getDate() + 1);
          resDate = "Завтра";
        }else if(propDate==="7 дней"){
          date.setDate(date.getDate() + 7);
          resDate = date.toLocaleString('ru', {year: 'numeric',month: 'long',day: 'numeric'});
        }else if(propDate==="2 недели"){
          date.setDate(date.getDate() + 14);
          resDate = date.toLocaleString('ru', {year: 'numeric',month: 'long',day: 'numeric'});
        }else if(propDate==="3 недели"){
          date.setDate(date.getDate() + 21);
          resDate = date.toLocaleString('ru', {year: 'numeric',month: 'long',day: 'numeric'});
        }
      }
      return resDate;
    },
    checkCompare(){
      this.activeCompare = !this.activeCompare;
      var cookieCompare = this.$cookie.get('compare');
      var compareJson = {};
      if( cookieCompare ){
        compareJson = JSON.parse(cookieCompare);
        if( this.activeCompare ) { //add
          if( !compareJson[this.site_id] ){
            compareJson[this.site_id]={};
            compareJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if( !compareJson[this.site_id][this.offerActual.IBLOCK_ID] ){
            compareJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
            compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          var searchId = compareJson[this.site_id][this.offerActual.IBLOCK_ID].find(el => el === this.offerActual.ID);
          if( !searchId ){
            compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
          }
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'add2comparison');
          }
        }else{ // remove
          compareJson[this.site_id][this.offerActual.IBLOCK_ID] = compareJson[this.site_id][this.offerActual.IBLOCK_ID].filter((n) => {return n != this.offerActual.ID});
        }
      }else{
        compareJson[this.site_id]={};
        compareJson[this.site_id][this.offerActual.IBLOCK_ID]=[];
        compareJson[this.site_id][this.offerActual.IBLOCK_ID].push(this.offerActual.ID);
      }
      this.$cookie.set('compare', JSON.stringify(compareJson))
      var cuntCompare = 0;
      for (var key in compareJson[this.site_id]) {
        cuntCompare = cuntCompare + compareJson[this.site_id][key].length;
      }
      this.$bus.$emit("compare", cuntCompare);
    },
    priceRequest(){
      this.popupOpenedPriceRequest=true;
    },
    sendFeedback() {
      /*if( !this.validPhone ){return false;}*/
      //this.loading = true;

      let inputTelVal = this.phone.replace(/^\D+/g, '').replace(/[^0-9]/g, '');
      const PHONE_REGEXP = /^\d+$/;
      const prone = PHONE_REGEXP.test(inputTelVal);
      if( !prone || ( typeof inputTelVal.length === "undefined" ||  inputTelVal.length < 7) ){
        document.querySelector('input[type="tel"]').classList.add('error');
        return false;
      } else {
        document.querySelector('input[type="tel"]').classList.remove('error');
      }

      this.$axios({
        url: '/ajax/?feadback=Y',
        method: 'post',
        params: {
          name: this.name,
          email: this.email,
          phone: this.phone,
          text: "Расчитать стоимость товара "+ this.offerActual.NAME +".",
          header: "Узнать цену",
          url: location.href
        }
      }).then(response => {
        if (response.status == 200 && response.data.success) {
          if (typeof (ym) === "function") {
            let yaCounterId = this.$store.state.langs.YACOUNTER;
            ym(yaCounterId, 'reachGoal', 'price_request');
          }
          this.sended = true;
          //console.log( "response", response );
        }else{
          console.log('Error feedback success: false')
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
      //this.loading = false;
    },
  }
}
</script>

<style lang="scss" scoped>
  .sber-wrapper {
    display: flex;
    background-color: white;
    align-items: center;
    padding: 5px;
    border-radius: 16px;
    margin-bottom: 4px;
  }
  .sber-wrapper--logo-wrapper {
    margin-right: 6px;
  }
  .sber-wrapper--text-wrapper {
    font-size: 14px;
  }

.layout-product-card {
  position: relative;
  background: #fff;
  padding: 15px;
  text-align: left;
  border-radius: 20px;
  box-shadow: 0px 4px 28px rgba(61, 74, 108, 0.12);

  .header {
    height: 60px;
  }
}
.price{
  white-space: nowrap;
}
.hidden {
  display: none !important;
}
.images {
  display: grid;
  grid-auto-columns: 100%;
  grid-auto-flow: column;
  transition: 0.5s;
}
.carousel {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}
.carousel-wrapper {
  position: relative;
  margin-bottom: 10px;
}
.comments {
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  gap: 4px;
  svg {
    width: 10px;
    height: auto;
  }
}
.image {
  padding-bottom: 80%;
  position: relative;
  cursor: pointer;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
    &.load {
      width: 24px;
      height: 24px;
      left: 50%;
      top: 50%;
    }
  }
}
.arrows {
  display: flex;
  align-items: center;
  justify-content: space-between;
  pointer-events: none;
  width: calc(100% + 2em);
  left: -1em;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
  .layout-product-card:hover & {
    opacity: 1;
    visibility: visible;
  }
  & > * {
    pointer-events: all;
  }
}
.dot {
  width: 5px;
  height: 5px;
  display: inline-block;
  margin: 2px;
  background: currentColor;
  border-radius: 10px;
  transition: 0.3s;
  opacity: 0.4;
  &.active {
    opacity: 1;
  }
}
.dots-indicator {
  position: absolute;
  right: 1em;
  bottom: 1em;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
  .layout-product-card:hover & {
    opacity: 1;
    visibility: visible;
  }
}
.data {
  display: grid;
  align-items: center;
  gap: 15px;
  padding-top: 10px;
}
.data.grid-template {
    grid-template-columns: repeat(2, 1fr);
}
.data {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 15px;
  padding-top: 10px;
}
.data {
  padding-top: 0;
}
.labels {
  position: absolute;
  left: 10px;
  top: 10px;
  & > * {
    margin-right: 2px;
    margin-bottom: 2px;
  }
}
.icon-button {
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  width: 1.875em;
  height: 1.875em;
  border-radius: 50px;
  position: relative;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
  svg {
    width: 1em;
    height: auto;
  }
  &:hover {
    transform: scale(1.1);
  }
  &.active {
    background: var(--color);
    color: #fff;
  }
}
.images-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.bottom-left {
  position: absolute;
  bottom: 10px;
  left: 10px;
}
.raiting {
  display: flex;
  align-items: center;
  margin-top: 1em;
}

.star {
  margin-right: 0.2em;
}
.amount {
  margin-left: 0.5em;
}

.size-select {
  background: var(--light);
  border-radius: 100px;
  padding: 0.3em 0.8em;
  cursor: pointer;
  transition: 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: var(--color);
    color: #fff;
  }
}

.pricing {
  display: flex;
  flex-direction: column;
}

.left-bottom {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
.delivery {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  align-self: center;
  justify-content: center;
}

.colors {
  margin: 5px 0;
  text-align: center;
  & > * {
    width: 24px;
    height: 9px;
    border-radius: 10px;
    display: inline-block;
    background: var(--color);
    background-size: cover;
    background-position: center;
    margin-right: 0.4em;
    cursor: pointer;
    transition: 0.3s;
    &:not(.active):hover {
      opacity: 0.6;
    }
    &.active {
      border: solid 2px #fff;
      box-shadow: 0px 0px 0px 2px;
    }
  }
}
.features {
  margin-top: 1em;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
  .layout-product-card:hover & {
    opacity: 1;
    visibility: visible;
  }
  & > * {
    display: inline-flex;
    align-items: center;
    margin-right: 1em;
    margin-bottom: 0.3em;
    span {
      font-size: 10px;
      font-weight: 500;
      text-transform: uppercase;
    }
  }
}
.size-select-wrapper {
  position: relative;
  z-index: 10;
}
.buttons {
  margin-top: 1em;
  opacity: 0;
  visibility: hidden;
  transition: 0.4s;
  & > * {
    cursor: pointer;
  }
  .layout-product-card:hover & {
    opacity: 1;
    visibility: visible;
  }
}
.button {
  background: var(--color);
  color: #fff;
  border-radius: 5px;
  padding: 0.8em 1.2em;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
  cursor: pointer;
  white-space: nowrap;
  svg {
    height: 1em;
  }
}
.buy {
  text-align: center;
  justify-content: center;
  margin: 0.5em 0.8em;
  display: inline-flex;
}
.options {
  position: absolute;
  top: calc(100% + 5px);
  width: 100%;
  left: 0;
  background: var(--color);
  border-radius: 20px;
  color: #fff;
  box-shadow: 0px 10px 20px rgba(61, 74, 108, 0.12);
  &.scrolled {
    height: 14em;
  }
  .selectItem {
    display: block;
    padding: 0.7em 1em;
    transition: 0.3s;
    border-radius: 100px;
    cursor: pointer;
    &:hover {
      background: rgba(255, 255, 255, 1);
      color: var(--color);
    }
    &.active {
      background: rgba(255, 255, 255, 0.1);
    }
  }
}
.hidden-chars {
  position: absolute;
  bottom: calc(100% + 3px);
  right: 0;
  background: #fff;
  box-shadow: 0px 4px 68px rgba(61, 74, 108, 0.32);
  border-radius: 20px 20px 0px 20px;
  padding: 15px;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  transform: translate(0, 10px);
  z-index: 10;
  width: 100%;
  height: 260px;
  overflow-y: auto;

  &.active {
    opacity: 1;
    visibility: visible;
    transform: translate(0, 0);
  }

  & > div {
    display: flex;
    align-items: center;
    gap: 12px;
    text-transform: uppercase;
    font-size: 12px;
    div {
      width: 40px;
      height: 40px;
      background: var(--light);
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      flex-shrink: 0;
      img {
        height: 22px;
        width: auto;
      }
    }
    b {
      display: block;
    }
    span {
      padding: 5px 0;
      flex-grow: 1;
    }
    &:not(:last-child) {
      margin-bottom: 3px;
      span {
        border-bottom: solid 1px var(--light);
      }
    }
  }
}
.compare-button.activeCompare{
  background: var(--color);
  color: #fff;
}
@media screen and (max-width: 767px) {
  .features,
  .arrows,
  .buttons,
  .dots-indicator {
    opacity: 1;
    visibility: visible;
  }
}
</style>
<style lang="scss">
.size-select-card-wrapper {
  .options {
    position: absolute;
    top: calc(100% + 5px);
    width: 100%;
    left: 0;
    background: var(--color);
    border-radius: 20px;
    color: #fff;
    box-shadow: 0px 10px 20px rgba(61, 74, 108, 0.12);

    &.scrolled {
      height: 14em;
    }

    .selectItem {
      display: block;
      padding: 0.7em 1em;
      transition: 0.3s;
      border-radius: 100px;
      cursor: pointer;

      &:hover {
        background: rgba(255, 255, 255, 1);
        color: var(--color);
      }

      &.active {
        background: rgba(255, 255, 255, 0.1);
      }
    }
  }
}
</style>
<style lang="scss" scoped>
/* loader */
.lds-ripple {
  display: inline-block;
  position: absolute;
  left: 50%;
  top: -20px;
  width: 20px;
  height: 20px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #dfc;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>